import { createFileRoute } from '@tanstack/react-router';
import { HrAttendancePage } from '@/features/attendance/attendance-pages';
import { guardRoute } from '@/lib/route-guards';

/** `/hr/attendance` (FR-ATT-11/12, FR-WFH-5, attendance.read.all): register, summary, WFH. */
export const Route = createFileRoute('/_app/hr/attendance')({
  beforeLoad: ({ context }) => {
    guardRoute(context.auth, '/hr/attendance');
  },
  component: HrAttendancePage,
});
